import querystring from 'querystring';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { ContentWrapper } from '@/components/b2b/shared/styles';
import { useAnalytics } from '@/hooks/analytics';

import { SignupScreenProps } from '../shared/types';
import messages from './messages';
import { Divider, PartnerButton, TextContainer } from './styles';

const Renew = ({ partnerDetails }: SignupScreenProps) => {
	const searchParams = useSearchParams();
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	useEffect(
		() => {
			logEvent({
				eventName: 'B2B : Renew : Landed',
				eventProps: {
					partner_id: partnerDetails.id,
				},
			});
		}, // TODO [WEB-1595]: Fix this exhaustive-deps issue
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	const subscribeQueryParams = useMemo(
		() => {
			return {
				// We remove the calm-link-token from window.location, but we don't remove it from next.js router.query,
				// so we use window.location.search here
				...querystring.parse(window.location.search.replace('?', '')),
				referer: `/b2b/${partnerDetails.slug}/renew`,
			};
		}, // TODO [WEB-1595]: Fix this exhaustive-deps issue
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[searchParams, partnerDetails.slug],
	);

	const onClickPartner = () => {
		logEvent({
			eventName: 'B2B : Renew : Clicked Renew with Partner',
			eventProps: {
				partner_id: partnerDetails.id,
			},
		});
	};

	const onClickCalm = () => {
		logEvent({
			eventName: 'B2B : Renew : Clicked Renew with Calm',
			eventProps: {
				partner_id: partnerDetails.id,
			},
		});
	};

	return (
		<ContentWrapper>
			{partnerDetails.web_renew_url ? (
				<>
					<TextContainer>
						{formatMessage(messages.logInWithPartnerDescription, {
							partnerName: partnerDetails.name,
						})}
					</TextContainer>
					<PartnerButton
						href={partnerDetails.web_renew_url}
						onPress={onClickPartner}
						backgroundColor="white"
						textColor="black"
						fullWidth
					>
						{formatMessage(messages.logInWithPartnerButton, {
							partnerName: partnerDetails.name,
						})}
					</PartnerButton>
					<Divider />
				</>
			) : null}
			<TextContainer>
				{formatMessage(
					partnerDetails.web_renew_url
						? messages.renewWithCalmInsteadDescription
						: messages.renewWithCalmDescription,
					{
						partnerName: partnerDetails.name,
					},
				)}
			</TextContainer>
			<Button
				href={`/subscribe?${querystring.stringify(subscribeQueryParams)}`}
				onPress={onClickCalm}
				backgroundColor="gradientCalmBrand"
				textColor="white"
				fullWidth
			>
				{formatMessage(messages.renewWithCalmButton, {
					partnerName: partnerDetails.name,
				})}
			</Button>
		</ContentWrapper>
	);
};

export default Renew;
